// CSS Modules - component class name: FeedbackForm__

<template>
  <form v-if="!showThankyou" :class="$style.container">
    <div class="columns">
      <div class="column">
        <FormSelect
          v-model.trim="$v.formData.subject.$model"
          :label="config.labels.subject.label"
          :errorMessage="config.labels.subject.errorMessage"
          :error="$v.formData.subject.$error && $v.$dirty && isSubmitted"
          :options="config.selectOptions"
          :initialOption="config.initialSelectOption"
        />
      </div>
      <div class="column">
        <FormInput
          v-model.trim="$v.formData.email.$model"
          :label="config.labels.email.label"
          :boldLabel="true"
          :errorMessage="config.labels.email.errorMessage"
          :error="$v.formData.email.$error && $v.$dirty && isSubmitted"
          :originalValue="previousData.email && previousData.email !== '' ? previousData.email : null"
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <FormTextarea
          v-model.trim="$v.formData.message.$model"
          :label="config.labels.message.label"
          :errorMessage="config.labels.message.errorMessage"
          :error="$v.formData.message.$error && $v.$dirty && isSubmitted"
          :rows="5"
          :columns="20"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column has-text-right-tablet">
        <Button
          colour="blue"
          text="Senden"
          type="submit"
          :isForm="true"
          @close="handleSubmit"
        >
        </Button>
      </div>
    </div>
    <div :class="$style.serverError" v-if="serverError">{{ config.serverErrorMessage }}</div>
    <ReCaptcha :executeSwitch="executeSwitch" :submit="submit" />
  </form>
</template>

<script>
import { email, required } from "vuelidate/lib/validators";
import ReCaptcha from "../ReCaptcha/ReCaptcha";
import FormInput from "../FormInput/FormInput";
import FormSelect from "../FormSelect/FormSelect";
import FormTextarea from "../FormTextarea/FormTextarea";
import Button from "../Button/Button";
import axios from "axios";
import { feedbackFormUrl as formUrl } from "../../shared/globals";

const noPlaceholderValue = value => value.indexOf("...") === -1;

export default {
  name: "FeedbackForm",
  components: {
    ReCaptcha,
    Button,
    FormInput,
    FormSelect,
    FormTextarea
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formData: {
        subject: "",
        email: "",
        message: "",
        domain: "",
        pageUrl: "",
        token: ""
      },
      previousData: {},
      isSubmitted: false,
      formSubmitSwitch: false,
      executeSwitch: false,
      showThankyou: false,
      serverError: false
    };
  },
  validations: {
    formData: {
      subject: {
        required,
        noPlaceholderValue
      },
      email: {
        required,
        email
      },
      message: {
        required
      }
    }
  },
  mounted() {
    if (this.config.initialSelectOption) {
      this.formData.subject = this.config.initialSelectOption;
    }
  },
  methods: {
    handleSubmit() {
      this.serverError = false;
      this.$v.$touch();
      this.isSubmitted = true;
      this.formSubmitSwitch = !this.formSubmitSwitch;
      if (!this.$v.$invalid) {
        this.executeSwitch = !this.executeSwitch;
      } else {
        this.previousData = JSON.parse(JSON.stringify(this.formData));
      }
    },
    submit(token) {
      this.formData.token = token;
      this.formData.domain = window.location.origin;
      this.formData.pageUrl = window.location.pathname;
      axios({
        url: formUrl,
        method: "post",
        data: this.formData,
        responseType: "json"
      })
        .then(response => {
          if (response.status === 200) {
            window.open(this.config.thankyouUrl, "_self");
          } else {
            this.serverError = true;
          }
        })
        .catch(error => {
          this.serverError = true;
          console.error(error);
        });
    }
  }
};
</script>

<style module lang="scss">
@import "./FeedbackForm.scss";
</style>
